import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, null, {
    default: _withCtx(() => [_createVNode(_component_van_divider), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_image, {
      height: "64",
      width: "64",
      src: _ctx.user.avatar
    }, null, 8, ["src"])]), _createVNode(_component_van_divider), _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "个人资料",
        icon: "user-circle-o",
        "is-link": "",
        "arrow-direction": "",
        to: "/wx/mine"
      }), _createVNode(_component_van_cell, {
        title: "存续资产",
        icon: "cash-back-record",
        "is-link": "",
        "arrow-direction": "",
        to: "/wx/hold-assets"
      }), _createVNode(_component_van_cell, {
        title: "到期/赎回资产",
        icon: "discount",
        "is-link": "",
        "arrow-direction": "",
        to: "/wx/redemption"
      }), _createVNode(_component_van_cell, {
        title: "我的财富顾问",
        icon: "manager-o",
        "is-link": "",
        "arrow-direction": "",
        to: "/wx/agent"
      })]),
      _: 1
    })]),
    _: 1
  });
}